import { faqItems } from '@/mocks/homeData';
import { useState } from 'react';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-foreground-500 text-center text-sm md:text-base mb-10">
          关于麻花影院的常见疑问，这里都有答案
        </p>
        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </h3>
                <i
                  className={`text-foreground-400 transition-transform duration-300 text-lg ${
                    openId === item.id ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === item.id ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}